export default "__VITE_ASSET__1eea4490__"